export const pathPermissions = {
  '/direct-fulfillment': 'directFulfillment',
  '/audit-logs': 'auditLogs',
  '/orders/fraud-orders': 'fraudOrders',
  '/orders/list': 'orders',
  '/deposits': 'deposits',
  '/subscriptions': 'subscriptions',
  '/store-products/list/:selectedTab': 'listings',
  '/account': 'profile',
  '/promotions-library': 'promotionsLibrary',
  '/browse-brand/store': 'listingsLibrary',
  '/request-sku': 'listingsAddNew',
  '/my-library': 'promotionsBrowse',
  '/my-promotions': 'promotions',
  '/homepage-banner': 'homepageBanner',
  '/configurations/users-access': 'settingsRequestOneLoginAccess',
  '/configurations/styles-palette': 'settingsColorPalette',
  '/configurations/summary': 'settingsSummary',
  '/configurations/recaptcha': 'settingsRecaptcha',
  '/configurations/plans': 'settingsUserPlans',
  '/configurations/coupon-manager': 'settingsCouponManager',
  '/configurations/social-media-links': 'settingsSocialMedia',
  '/configurations/bluepay': 'settingsPaymentMethods',
  '/configurations/store-pickup-locations': 'settingsPickupLocations',
  '/configurations/rewards': 'settingsRewards',
  '/configurations/notifications': 'settingsNotifications',
  '/configurations/shipping': 'settingsShipping',
  '/configurations/comparelist': 'settingsCompare',
  '/configurations/wishlist': 'settingsWhishlist',
  '/configurations/reviews': 'settingsReview',
  '/configurations/homepage': 'settingsHomepage',
  '/configurations/tagline': 'settingsTagline',
  '/configurations/general': 'settingsGeneral',
  '/configurations/referral-program': 'settingsReferralProgram',
  '/settings': 'settings',
  '/admin': 'adminPanel',
  '/customers/list': 'customersList',
  '/customers/import': 'customersImport',
  '/customers/request-access': 'customersRequestAccess',
  '/marketing': 'marketing',
  '/help/:categoryUrl?/:subCategoryUrl?/:topicUrl?': 'help',
  '/configurations/tax-rates': 'settingsTaxRates',
  '/affiliates': 'affiliate',
  '/configurations/promos': 'settingsHomepagePromoTabs',
  '/configurations/promo-carousels': 'settingsHomepagePromoCarousels',
  '/configurations/homepage/welcome-block': 'settingsHomepageWelcomeBlock',
  '/configurations/homepage/cta': 'settingsHomepageCTABlock',
  '/configurations/homepage/modern-cta': 'settingsHomepageCTABlock',
  '/configurations/homepage/reward-block': 'settingsHomepageRewardBlock',
  '/configurations/homepage/testimonials': 'settingsHomepageTestimonials',
  '/configurations/homepage/blog': 'settingsHomepageBlogBlock',
  '/configurations/homepage/premium-cta': 'settingsHomepagePremiumCTA',
  '/configurations/homepage/instagram-widget': 'settingsHomepageInstagramBlock',
  '/configurations/about-us-page': 'settingsAboutUsPage',
  '/configurations/before-after-gallery': 'settingsBeforeAfterGallery',
  '/configurations/homepage/appointment-form': 'settingsAppointmentFormBlock',
  '/configurations/dns': 'settingsDNS',
  '/quoting/profile/:id/quote-workspace/summary': 'quotingV2',
  '/quoting/profile/:id/quote-workspace/summary/plan': 'quoteTreatmentPlan',
  '/quoting/profile/:id/(edit-listings)?': 'quotingV2',
  '/quoting/profile/:id/quote-workspace': 'quotingV2',
  '/quoting': 'quotingV2',
  '/quoting/automatedQuotes': 'automatedQuotes',
  '/quoting/listings/:selectedTab': 'quoteListings',
  '/quoting-demo/create-quote': 'quoteDemo',
  '/quoting-demo/patient/profile/:patientId?': 'quoteDemo',
  '/quoting-demo/patient/create': 'quoteDemo',
  '/quoting-demo/patien': 'quoteDemo',
  '/analytics': 'analytics',
  '/data-mapping/:selectedTab': 'dataMapping',
  '/sync-event-logs': 'syncEventLogs',
  '/gift-cards': 'giftCards',
  '/gift-cards/create-gift-code': 'giftCardsCreate',
  '/quoting/marketing-segments': 'quoteMarketingSegments',
  '/quoting/groups': 'quoteGroups',
  '/quoting/queue': 'quoteMarketingSegments',
  '/orders/list/mdi': 'ordersMDI',
  '/orders/list/dr-dauer': 'ordersDrDauer',
};
